import React from 'react';
import { Fragment } from 'react';
import Footer from '../../../components/footer';
import Head from '../../../components/head';
import Header from '../../../components/headerfunc';
import Holerites from '../../../components/funcionarios/holerites';


function HomeHoleritesScreen () {
    return (
        <Fragment>
            <Head titulo="Suas Holerites | Consórcio LVF" />
            <Header />
            <Holerites />
            <Footer />
        </Fragment>
    );
}

export default HomeHoleritesScreen;